<template>
  <!--begin::App-->
  <div class="app-root" id="kt_app_root">
    <!--begin::Page-->
    <div class="app-page" id="kt_app_page">
      <div class="forgot-password p-4">
        <div class="container h-100">
          <div class="d-flex flex-column flex-lg-row justify-content-lg-between bg-white br-40 h-100">
            <div class="col-12 col-lg-6 order-1 order-lg-0">
              <div class="d-flex flex-column justify-content-center h-100 p-10">
                <router-link class="logo" :to="'/'">
                  <img src="/images/layout/logo-pixel-principal.png" alt="Pixel Roads" class="logo mt-3 mb-10" />
                </router-link>
                <h1 class="font3 font-size-xLarge font-size-md-xxLarge fw-300 lh-1 mb-5">
                  {{ $t('forgot') }}<br>
                  <span class="fw-700">{{ $t('your_password_question') }}</span>
                </h1>
                <!-- SEND RESET LINK FORM -->
                <form @submit.prevent="submit" class="default-form">
                  <div class="form-group">
                    <label class="form-label font-size-xMedium font3">{{ $t('email') }}</label>
                    <input type="email" class="form-control form-control-sm" v-model.trim="$v.form.email.$model" :placeholder="$t('enter_your_email')" />
                  </div>
                  <div class="mt-5">
                    <Button
                      type="submit"
                      class="btn-color5 btn-lg w-100"
                      :disabled="$v.$invalid"
                      :loading="loader"
                    >
                      {{ $t('send_reset_link') }}
                    </Button>
                  </div>
                  <div class="d-flex gap-10 justify-content-center align-items-center my-3">
                    <hr class="border border-dark col-5"/>{{ $t('or') }}<hr class="border border-dark col-5"/>
                  </div>
                  <router-link class="btn btn-outline btn-lg w-100 mb-10" :to="'/'">
                    {{ $t('return_to_the_login_page') }}
                  </router-link>
                </form> <!-- END SEND RESET LINK -->
              </div>
            </div>
            <div class="col-12 col-lg-6 order-0 order-lg-1 d-none d-lg-block position-relative text-end login-image">
              <div class="h-100">
                <div class="position-absolute w-100 d-flex justify-content-end">
                  <select v-model="$i18n.locale" id="language" class="form-select font-size-small border-0 w-auto" @change="handleLanguageChange">
                    <option value="pt_BR">PT</option>
                    <option value="en" selected>EN</option>
                    <option value="es">ES</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TheFooter />
    </div>
    <!--end::Page-->
  </div>
  <!--end::App-->
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import UsersService from '@/modules/users/services/users-service'
import { required, email } from 'vuelidate/lib/validators'

import Button from '@/components/common/Button/Button'
import TheFooter from '@/components/footers/TheFooter2'

export default {
  name: 'ForgotPassword',
  components: {
    Button,
    TheFooter
  },
  data () {
    return {
      loader: false,
      form: {
        email: ''
      }
    }
  },
  metaInfo () {
    return {
      title: this.$t('change_password')
    }
  },
  validations () {
    return {
      form: {
        email: { required, email }
      }
    }
  },
  created () {
    this.handleLanguage()
  },
  methods: {
    async handleLanguage () {
      const language = await UsersService.getCookie('user_language')
      if (language) {
        this.$i18n.locale = language
      } else {
        await UsersService.setCookie('user_language', 'pt_BR', 30)
        this.$i18n.locale = 'pt_BR'
      }
    },
    async handleLanguageChange () {
      await UsersService.setCookie('user_language', this.$i18n.locale, 30)
    },
    /**
     * Send reset email
     */
    async submit () {
      this.loader = true
      try {
        await AuthService.sendResetPasswordEmail(this.form.email)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('email_instructions_changing_password')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.form.email = ''
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    reset () {
      this.form.email = ''
    }
  }
}

</script>

<style lang="scss" scoped>
  .logo {
    img {
      width: 150px;
    }
  }

  .app-page {
    flex-direction: column;
    overflow: hidden;
    background: #F8F9FA;
  }

  .app-root, .app-page {
    @media (min-height: 768px) {
      height: 100%;
    }
    @media (min-height: 1200px) {
      height: auto;
    }
  }

  .forgot-password {
    background: #ECD263;
    height: 100%;
  }

  .login-image {
    border-radius: 0 0 40px 0;
    max-height: 100%;
    background: url('/images/v2/layout/image-login.jpg') no-repeat;
    background-size: cover;
  }
</style>
